export const enClientPortalValuationPageLayout = {
    sectionLabel: 'VALUATION',
}
